import React from 'react'
import "../../../styles/quienesSomos/Nuestra_firma.css"
import Logo from '../../Reutilizables/Logo'
import Menu from '../../Reutilizables/Menu'
import MenuInicioSuscrito from '../inicioSuscrito/MenuInicioSuscrito'
import Redes from "../../Reutilizables/Redes"
import Footer from '../../Reutilizables/Footer'
import TituloImpuestosMunicipales from "../../Reutilizables/TituloImpuestosMunicipales"

function NuestraFirma({ user }) {
  return (
        <div>
            <div className='container-logo-menu'>
              <Logo />

              {
                user ? <MenuInicioSuscrito /> : <Menu />
              }

            </div>
            <Redes />
            <TituloImpuestosMunicipales />
            <div className="container-nuestra-firma">

            <section className="section-info-nuestra-firma">
              <h3>Nuestra firma</h3>
              <p className='parrafo-section-info-nuestra-firma'>
                Tributos & Finanzas es una empresa dedicada a orientar y asesorar en el campo tributario y jurídico a entes públicos y 
                privados del país. Brindamos soluciones oportunas de acuerdo con las leyes y normas establecidas dentro del territorio 
                nacional, asegurando la calidad y confiabilidad de nuestros servicios. Contribuimos al desarrollo y crecimiento económico 
                de la sociedad, generando valor, progreso y utilidad a la compañía.
              </p>
            </section>

            <section className="section-info2-politica-calidad">
              <h3>Politica de calidad</h3>
              <p className='parrafo-section-info2-politica-calidad'>
                Tributos & Finanzas S.A.S será, para el año 2030, una empresa líder a nivel nacional en la capacitación y asesoría
                a entidades territoriales en temas tributarios, financieros y apoyo jurídico.
              </p>
            </section>

            <section className="section-info2-objetivos-calidad">
              <h3>Objetivos de calidad</h3>
              <div className='parrafo-section-info2-objetivos-calidad'>
                <p>1. Prestar un servicio bajo los criterios de eficacia y eficiencia.</p>
              </div>
              <div className='parrafo-section-info2-objetivos-calidad'>
                <p>2. Mejorar permanentemente el sistema de gestión de calidad.</p>
              </div>
              <div className='parrafo-section-info2-objetivos-calidad'>
                <p>3. Mantener siempre actualizada a la empresa en los cambios normativos relacionados con la actividad.</p>
              </div>
            </section>

            </div>
            <Footer />
        </div>
    )
}

export default NuestraFirma
